import { useTranslation } from "react-i18next";

/**
 * Phase32 — page-level Garmin attribution note for screens that aggregate
 * activity / wellness data across many devices, where per-element
 * attribution is impractical. Recommended by intervals.icu owner per
 * intervals.icu API Terms 1.1.
 */
export function DataAttributionNote() {
  const { t } = useTranslation();
  return <p className="data-attribution-note">{t("device_attribution.data_note")}</p>;
}
